import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Divider from '../Divider';
import { StyledAppBar, StyledAppBarWrapper, StyledAppBarContent } from './styled';
import { makeStyles } from '../../utils/styles';
import Logo from '../Logo';
import useTheme from '../../hooks/useTheme';
import i18n from '../../i18n';
import Select from '../Select';
import { useDispatch } from 'react-redux';
import { setLanugage } from '../../redux/lang/actions';

const useStyles = makeStyles(css => ({
    divider: css`
        margin: 0 40px;
    `
}));

const AppBar = ({ children }) => {
    const dispatch = useDispatch();
    const styles = useStyles();
    const theme = useTheme();
    const onSelectLanguage = useCallback((lang) => {
        if (lang === i18n.language) return
        dispatch(setLanugage(lang))
    }, [dispatch])

    return (
        <StyledAppBar>
            <StyledAppBarWrapper>
                <Logo
                    width={63}
                    height={26}
                    variant="purple"
                    customStyle={styles.logo}
                />
                <Divider
                    orientation="vertical"
                    flexItem
                    customStyle={styles.divider}
                />
                <StyledAppBarContent>
                    {children}
                </StyledAppBarContent>
                <Select
                    id='language-select'
                    value={i18n.language}
                    options={[{
                        label: "Polski",
                        value: "pl-PL"
                    }, {
                        label: "English",
                        value: "en-GB"
                    }]}
                    customStyle={{ marginBottom: 0, marginLeft: 30 }}
                    noBorder
                    font={theme.fonts.mulishRegular}
                    onChange={(e) => onSelectLanguage(e.target.value)}
                />
            </StyledAppBarWrapper>
        </StyledAppBar>
    );
};

AppBar.propTypes = {
    children: PropTypes.node
};

export default React.memo(AppBar);
